import {ReactComponent as AnnounceIcon} from '../../../../assets/images/icons/announcement.svg';
import {ReactComponent as ScheduleIcon} from '../../../../assets/images/icons/schedule.svg';
import {useI18n} from '../../../common/providers/I18nProvider';

interface SchedulePropTypes {
	storeName?: string;
	groupCount?: number;
}

interface Schedules {
	scheduleData?: SchedulePropTypes[];
}
export default function Schedule({scheduleData}: Schedules) {
	const {i18n} = useI18n();

	return (
		<div className='sm:bg-white sm:p-6 sm:rounded-lg'>
			<div className='flex justify-between mb-4 sm:mb-7'>
				<div className='flex items-center'>
					<ScheduleIcon className='h-6 w-6 sm:h-7 sm:w-7 lg:h-8 lg:w-8' />
					<span className='lg:text-xl font-medium text-black-10 ml-3'>{i18n('DASHBOARD.SCHEDULE.TITLE')}</span>
				</div>
			</div>

			<div className='grid gap-4'>
				{scheduleData && scheduleData[0] ? (
					scheduleData?.map((data) => (
						<div className='bg-[#FBEFEB] rounded-md py-4 px-2 sm:px-12 flex' key={data.storeName}>
							<AnnounceIcon />
							<span className='text-[18px] md:text-[18px] text-black-10 ml-1 sm:ml-4'>
								<strong>{i18n('DASHBOARD.SCHEDULE.NOTICE.PART.1', {count: data.groupCount})}</strong>{' '}
								<strong>{data.storeName}</strong> {i18n('DASHBOARD.SCHEDULE.NOTICE.PART.2')}
							</span>
						</div>
					))
				) : (
					<div className='bg-[#FBEFEB] rounded-md py-4 px-2 sm:px-12 flex'>
						<span className='text-sm md:text-base lg:text-lg pl-8 sm:px-0'>{i18n('COMMON.NO.RECORDS')}</span>
					</div>
				)}
			</div>
		</div>
	);
}
